import { replace } from 'react-router-redux';

import apiSubmitCall from '../../utils/call/callApi';
import { ACTION_COMPLETED_LOCAL_REP, onFinishMultiAction } from '../Widget/actions';

export const CALL_SUBMITTING = 'CALL_SUBMITTING';
export const CALL_SUCCESS = 'CALL_SUCCESS';
export const CALL_INITIATED = 'CALL_INITIATED';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';
export const IS_PHONE_LINK_CLICKED = 'IS_PHONE_LINK_CLICKED';

export const onCallComplete = (
    apiRequestData,
    actionCompletedTime,
    isMultiActionsCard,
    actionIdentifier,
    thankYouText,
    thankYouTitle,
    isPhoneLinkClicked,
    localRepresentativeState,
    useLocalRepresentative,
    recipientName,
    skipEndCard
) => dispatch => {
    dispatch({
        type: CALL_SUBMITTING,
        payload: true
    });

    if (isPhoneLinkClicked) {
        dispatch({
            type: IS_PHONE_LINK_CLICKED,
            payload: true
        });
    }

    apiSubmitCall(apiRequestData, actionCompletedTime).then(data => {
        dispatch({
            type: CALL_SUCCESS,
            payload: {
                ...data,
                actionIdentifier,
                thankYouText,
                localRepresentativeState
            }
        });

        dispatch({
            type: SET_SUCCESS_INFO,
            payload: {
                thankYouText,
                thankYouTitle,
                useLocalRepresentative,
                localRepresentativeState,
                apiRequestData,
                recipientName
            }
        });

        dispatch({
            type: ACTION_COMPLETED_LOCAL_REP
        });

        if (isMultiActionsCard) {
            onFinishMultiAction(actionIdentifier)(dispatch);
        } else if (!skipEndCard) {
            dispatch(replace('/call/success'));
        }

        setTimeout(() => {
            dispatch({
                type: CALL_SUBMITTING,
                payload: false
            });
        }, 400);
    });

    return true;
};

export const onContainerClick = actionIdentifier => dispatch => {
    dispatch({
        type: CALL_INITIATED,
        payload: actionIdentifier
    });
};



// WEBPACK FOOTER //
// ./src/containers/Call/actions.js